import React, { useEffect, useState, useRef } from 'react'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import PersonAddAlt1SharpIcon from '@mui/icons-material/PersonAddAlt1Sharp'
const CardSearchAccess = ({ props, func }) => {
  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'space-between',
          paddingTop: '30px',
        }}
      >
        <div>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              marginBottom: '10px',
            }}
          >
            {props.photo && (
              <Avatar
                alt={props.name}
                src={props.photo}
                sx={{ width: 45, height: 45 }}
              />
            )}
            <div>
              <Typography variant="body2" gutterBottom>
                {props.surname} {props.name} {props?.patronymic}
              </Typography>
              <Typography variant="body2" gutterBottom>
                Судейская категория: {props.rank}
              </Typography>
            </div>
          </Stack>
        </div>
        <IconButton onClick={(e) => func(props)}>
          <PersonAddAlt1SharpIcon style={{ color: 'green' }} />
        </IconButton>
      </Stack>
    </>
  )
}
export default CardSearchAccess
